$(function () {
  $("#filters_narrow").on('click', function () {
    $(".filters_narrow_list").slideToggle();
    var nowclass = $(this).attr("class");
    console.log(nowclass);
    if (nowclass == 'open') {
      $(this).removeClass("open");
      $(this).addClass("close");
    } else {
      $(this).removeClass("close");
      $(this).addClass("open");
    }
  });
});

// 肉の種類・ジャンルで選ぶ
$(function () {
  $(".products__sort .button").on("click", function () {
    $(".products__sort .button").removeClass("active");
    $(this).addClass("active");
  })
})
$(function () {
  var $grid = $(".list_menu").isotope({
    itemSelector: ".list_menu_item",
  });

  // store filter for each group
  var filters = {};

  $(".filters").on("click", ".button", function (event) {
    var $button = $(event.currentTarget);
    // get group key
    var $buttonGroup = $button.parents(".button-group");
    var filterGroup = $buttonGroup.attr("data-filter-group");
    // set filter for group
    filters[filterGroup] = $button.attr("data-filter");
    // combine filters
    var filterValue = concatValues(filters);
    // set filter for Isotope
    $grid.isotope({ filter: filterValue });
  });

  // change is-checked class on buttons
  $(".button-group").each(function (i, buttonGroup) {
    var $buttonGroup = $(buttonGroup);
    $buttonGroup.on("click", "button", function (event) {
      $buttonGroup.find(".is-checked").removeClass("is-checked");
      var $button = $(event.currentTarget);
      $button.addClass("is-checked");
    });
  });

  // flatten object by concatting values
  function concatValues(obj) {
    var value = "";
    for (var prop in obj) {
      value += obj[prop];
    }
    return value;
  }
});

$(function () {
  $(".card_shipping_price_area").on('change', function () {
    var now_id = ".card_shipping_price#" + $(this).parent("section").attr("id");
    $(".card_shipping_price" + now_id + " div").css("display", "none");
    var select_area = $(now_id + " .card_shipping_price_area option:selected").val();
    console.log("select_area:" + select_area);
    $(".card_shipping_price" + now_id + " " + select_area).css("display", "inline-block");
  });
});

/*
$(function () {
  $(".product-card .grid_title h3 a").each(function () {
    var item_name = $(this).text();
    var item_name_before = item_name.slice(0, item_name.indexOf("】") + 1);
    var item_name_after = item_name.slice(item_name.indexOf("】") + 1);
    var item_list_name = item_name_before + "<br>" + item_name_after;
    $(this).html(item_list_name);
  });
});

*/